<template>
  <v-app-bar class="pr-3 elevation-0" fixed app :color="themeColor">
    <v-toolbar-title class="ml-0 pl-3">
      <v-app-bar flat :color="themeColor" @click.stop="handleDrawerToggle">
        <v-btn icon>
          <v-icon>menu</v-icon>
        </v-btn>
      </v-app-bar>
    </v-toolbar-title>
    <template v-if="this.$store.state.course.course">
      <v-btn
        text
        :to="{
          name: 'course',
          params: {
            courseId: this.$store.state.course.id,
            slug: this.$store.state.course.slug,
          },
        }"
      >
        {{ this.$store.state.course.course }}
      </v-btn>
    </template>
    <v-spacer></v-spacer>
    <v-tooltip v-if="isOffline" bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" icon>
          <v-icon>wifi_off</v-icon>
        </v-btn>
      </template>
      Você está offline!
    </v-tooltip>
    <!-- Authenticated -->
    <v-btn icon @click="handleFullScreen()">
      <v-icon>{{ isFullscreen ? "fullscreen_exit" : "fullscreen" }}</v-icon>
    </v-btn>
    <v-menu
      offset-y
      origin="center center"
      :nudge-bottom="10"
      v-if="this.authenticated"
    >
      <template v-slot:activator="{ on }">
        <!--        <v-btn text v-on="on"-->
        <!--               dark>-->
        <!--          {{ user.name }}-->
        <!--        </v-btn>-->
        <v-btn icon v-on="on">
          <v-avatar>
            <img :src="user.avatar" :alt="user.name" />
          </v-avatar>
        </v-btn>
      </template>
      <v-list class="pa-0">
        <v-list-item
          v-for="(item, index) in items"
          :to="!item.href ? { name: item.name } : null"
          :href="item.href"
          @click="item.click"
          ripple="ripple"
          :disabled="item.disabled"
          :target="item.target"
          rel="noopener"
          :key="index"
        >
          <v-list-item-action v-if="item.icon">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
    <template v-else>
      <v-btn text :to="{ name: 'login' }">
        <v-icon>account_circle</v-icon>
        <v-spacer></v-spacer>
        Entrar
      </v-btn>
    </template>
    <v-btn
      v-if="this.$route.name === 'classroom'"
      icon
      @click="handleDrawerContentToggle()"
    >
      <v-icon>list_alt</v-icon>
    </v-btn>
  </v-app-bar>
</template>
<script>
import NotificationList from "@/components/widgets/list/NotificationList";
import Util from "@/util";
import { mapGetters } from "vuex";

export default {
  name: "app-toolbar",
  components: {
    NotificationList,
  },
  mounted() {
    window.addEventListener("offline", () => {
      console.log("went off");
      this.isOffline = true;
    });
    window.addEventListener("online", () => {
      console.log("went on");
      this.isOffline = false;
    });
  },
  data: () => ({
    isOffline: !navigator.onLine,
    isFullscreen: document.fullscreenElement !== null,
    items: [
      {
        icon: "account_circle",
        // href: '/user/profile',
        name: "profile",
        title: "Meu Perfil",
        click: (e) => {
          // console.log(e)
        },
      },
      {
        icon: "settings",
        href: "#",
        // name: 'settings',
        title: "Configurações",
        click: (e) => {
          window.getApp.openThemeSettings();
        },
      },
      {
        icon: "exit_to_app",
        href: "#",
        title: "Sair",
        click: (e) => {
          window.getApp.$emit("APP_LOGOUT");
        },
      },
    ],
  }),
  computed: {
    ...mapGetters({
      user: "authUser",
      authenticated: "authCheck",
    }),

    themeColor() {
      return this.$vuetify.theme.dark ? "#121212" : "#ffffff";
    },
  },
  methods: {
    handleDrawerToggle() {
      window.getApp.$emit("APP_DRAWER_TOGGLED");
    },
    handleDrawerContentToggle() {
      window.getApp.$emit("APP_DRAWER_CONTENT_TOGGLED");
    },
    handleFullScreen() {
      this.isFullscreen = !this.isFullscreen;
      Util.toggleFullScreen();
    },
  },
};
</script>
